import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { RouteErrorFallback } from '@/shared/components/error-boundaries/RouteErrorFallback';
import { buildRoutePermissionEntries, setRoutePermissionEntries } from '@/shared/lib/permissions';
import { applyPermissionGuards } from './applyPermissionGuards';
import type { RamRouteObject } from '@/shared/lib/permissions';
import { bankAccountRoutes } from '@/pages/bank-accounts/routes';
import { assetAnalyserRoutes } from '@/pages/asset-analyser/routes';
import { assetRoutes, assetStandaloneRoutes } from '@/pages/assets/routes';
import { bkaRoutes } from '@/pages/bka/routes';
import { capexEeConfigRoutes } from '@/pages/capex-ee-config/routes';
import { companyRoutes } from '@/pages/companies/routes';
import { contactRoutes } from '@/pages/contacts/routes';
import { contractRoutes } from '@/pages/contracts/routes';
import { documentClassifierRoutes } from '@/pages/document-classifier/routes';
import { envelopeRoutes } from '@/pages/envelopes/routes';
import { financialRoutes } from '@/pages/financial-management/routes';
import { institutionalRoutes } from '@/pages/institutional/routes';
import { agentRoutes } from '@/pages/agents/routes';
import { administrationRoutes } from '@/pages/administration/routes';
import { investorShareRoutes } from '@/pages/investor-shares/routes';
import { myTasksRoutes } from '@/pages/my-tasks/routes';
import { ownerRoutes } from '@/pages/owners/routes';
import { invoiceRoutes } from '@/pages/invoices/routes';
import { sepaMandateRoutes } from '@/pages/sepa-mandates/routes';
import { sevOnboardingRoutes } from '@/pages/sev-onboarding/routes';
import { tenancyRoutes } from '@/pages/tenancies/routes';
import { tenantRoutes } from '@/pages/tenants/routes';
import { unitRoutes } from '@/pages/units/routes';
import { financialStatementRoutes } from '@/pages/financial-statements/routes';
import { paymentForecastRoutes } from '@/pages/payment-forecast/routes';
import { renovationOverviewRoutes } from '@/pages/renovation-overview/routes';

const App = lazy(() => import('@/app/App'));
const Dashboard = lazy(() => import('@/pages/dashboard/Dashboard'));

export const ramRouteTree: RamRouteObject[] = [
    ...assetStandaloneRoutes,
    {
        path: '/',
        element: <App />,
        errorElement: <RouteErrorFallback />,
        children: [
            {
                index: true,
                element: <Dashboard />,
            },
            // Module routes
            ...assetRoutes,
            ...companyRoutes,
            ...contactRoutes,
            ...tenancyRoutes,
            ...unitRoutes,
            ...renovationOverviewRoutes,
            ...contractRoutes,
            ...ownerRoutes,
            ...tenantRoutes,
            ...bkaRoutes,
            ...bankAccountRoutes,
            ...financialRoutes,
            ...sepaMandateRoutes,
            ...investorShareRoutes,
            ...sevOnboardingRoutes,
            ...envelopeRoutes,
            ...invoiceRoutes,
            ...myTasksRoutes,
            ...documentClassifierRoutes,
            ...institutionalRoutes,
            ...administrationRoutes,
            ...agentRoutes,
            ...capexEeConfigRoutes,
            ...financialStatementRoutes,
            ...paymentForecastRoutes,
            ...assetAnalyserRoutes,
        ],
    },
];

setRoutePermissionEntries(buildRoutePermissionEntries(ramRouteTree));

export const router = createBrowserRouter(applyPermissionGuards(ramRouteTree));
